export const footerOffset = 100;
